import { render, staticRenderFns } from "./Boy.vue?vue&type=template&id=1ce8761c&scoped=true&"
import script from "./Boy.vue?vue&type=script&lang=ts&"
export * from "./Boy.vue?vue&type=script&lang=ts&"
import style0 from "./Boy.vue?vue&type=style&index=0&id=1ce8761c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce8761c",
  null
  
)

export default component.exports